export function successCompareCandidates(data) {
  $('.candidate-analysis-comparison').html(data.html);
}

export function errorCompareCandidates(data) {
  $('.candidate-analysis-comparison').html(data.html);
}
